// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeItem-space1-r8OMh {
	margin-bottom: 6px !important;
}

.HomeItem-space2-w_6Dn {
	margin-bottom: 12px !important;
}

.HomeItem-space3-nuqYJ {
	margin-bottom: 18px !important;
}

.HomeItem-space4-HuTTx {
	margin-bottom: 24px !important;
}

.HomeItem-space5-ZKcFU {
	margin-bottom: 30px !important;
}

.HomeItem-space6-vCf5g {
	margin-bottom: 36px !important;
}

.HomeItem-space7-Rr7FT {
	margin-bottom: 42px !important;
}

.HomeItem-spaceTop8-pUzHz {
	margin-bottom: 48px !important;
}

.HomeItem-spaceTop1-VxuDF {
	margin-top: 6px !important;
}

.HomeItem-spaceTop2-i_nFw {
	margin-top: 12px !important;
}

.HomeItem-spaceTop3-cpSC4 {
	margin-top: 18px !important;
}

.HomeItem-spaceTop4-btJ3O {
	margin-top: 24px !important;
}

.HomeItem-spaceTop5-Rqx07 {
	margin-top: 30px !important;
}

.HomeItem-spaceTop6-zcWYh {
	margin-top: 36px !important;
}

.HomeItem-spaceTop7-KaBcP {
	margin-top: 42px !important;
}

.HomeItem-spaceTop8-pUzHz {
	margin-top: 48px !important;
}

.HomeItem-noMargin-hboDP {
	margin: 0px !important;
}

.HomeItem-padding1-DeNhq {
	padding-bottom: 6px !important;
}

.HomeItem-padding2-lepQ2 {
	padding-bottom: 12px !important;
}

.HomeItem-padding3-CIBR8 {
	padding-bottom: 18px !important;
}

.HomeItem-padding4-q0BSV {
	padding-bottom: 24px !important;
}

.HomeItem-padding5-pskaJ {
	padding-bottom: 30px !important;
}

.HomeItem-padding6-fBGxm {
	padding-bottom: 36px !important;
}

.HomeItem-padding7-Gbbx5 {
	padding-bottom: 42px !important;
}

.HomeItem-paddingTop1-VWkQy {
	padding-top: 6px !important;
}

.HomeItem-paddingTop2-_ueB_ {
	padding-top: 12px !important;
}

.HomeItem-paddingTop3-iDPXy {
	padding-top: 18px !important;
}

.HomeItem-paddingTop4-oQSdV {
	padding-top: 24px !important;
}

.HomeItem-paddingTop5-_KtSr {
	padding-top: 30px !important;
}

.HomeItem-paddingTop6-ONwil {
	padding-top: 36px !important;
}

.HomeItem-paddingTop7-mbrAj {
	padding-top: 42px !important;
}

.HomeItem-noPadding-TejZ8 {
	padding: 0px !important;
}

.HomeItem-textBold-ENEZI {
	font-weight: 500 !important;
}

.HomeItem-textBolder-GxpnC {
	font-weight: 700 !important;
}

.HomeItem-textNormal-QVNnO {
	font-weight: normal !important;
}

.HomeItem-spaceBottom20-PqUTg {
	margin-bottom: 20px;
}

.HomeItem-spaceBottom10-arU2L {
	margin-bottom: 10px;
}

.HomeItem-marginNone-MmGFf {
	margin: 0;
}

.HomeItem-spaceBottom15-N66FF {
	margin-bottom: 15px;
}

.HomeItem-marginTopNone-GCRzF {
	margin-top: 0;
}

.HomeItem-spaceTop11-t03iT {
	margin-top: 11px;
}

.HomeItem-spaceTop21-otN0q {
	margin-top: 21px;
}

.HomeItem-spaceTop20-YWUb9 {
	margin-top: 20px;
}

.HomeItem-spaceTop10-PgcIC {
	margin-top: 10px;
}

/*New Design Text Colors */

.HomeItem-textDarkBlue-m4t_o {
	color: rgb(20, 39, 94) !important;
}

.HomeItem-textLightBlue-BWA58 {
	color: rgb(57, 87, 106) !important;
}

.HomeItem-textLightSandleGreen-VvoM3 {
	color: rgb(76, 86, 41) !important;
}

.HomeItem-textLightBrown-V3JRd {
	color: rgb(115, 79, 33) !important;
}

.HomeItem-textMediumMaroon-hJVuq {
	color: rgb(87, 37, 51) !important;
}

.HomeItem-textBrown-zk5Or {
	color: rgb(160, 47, 24) !important;
}

.HomeItem-textMaroon-EylgK {
	color: rgb(155, 49, 67) !important;
}

.HomeItem-textDarkBrown-VVaVc {
	color: rgb(83, 18, 16) !important;
}

.HomeItem-textMediumBrown-y0O3m {
	color: rgb(142, 28, 10) !important;
}

.HomeItem-textSkyBlue-mgZeT {
	color: rgb(37, 117, 141) !important;
}

.HomeItem-textGray-KVCcB {
	color: rgb(77, 65, 51) !important;
}

/** Common **/

.HomeItem-textEllipsis-aHUlH {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/** Common **/

/** Home slider Item - Start **/

.HomeItem-imgContainer-ccoyu {
	position: relative;
	width: 100%;
	background: var(--secondary-gray-bg);
	border-radius: 15px;
}

.HomeItem-parent-B_6aP {
	background: var(--secondary-gray-bg) none repeat scroll 0 0;
	padding-top: 67.6667%;
	position: relative;
	border-radius: 15px;
	overflow: hidden;
}

.HomeItem-children-qYRqD {
	bottom: 0;
	height: 100%;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
}

.HomeItem-content-NVJX7 {
	height: 100%;
	width: 100%;
	position: relative;
}

.HomeItem-imageContent-NQcw0 {
	height: 100%;
	width: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	position: absolute;
}

.HomeItem-infoContainer-RbJK0 {
	position: relative;
}

.HomeItem-linkContainer-qZQbd,
.HomeItem-linkContainer-qZQbd:hover {
	display: block;
	text-decoration: none;
	cursor: pointer;
}

.HomeItem-infoReview-pgMUd {
	font-size: 16px;
	font-weight: 500;
}

.HomeItem-infoTitle-u02Qa {
	font-size: 18px;
	font-weight: 500;
	margin-top: 3px;
	color: var(--primary-foreground);
}

.HomeItem-infoDesc-rOoWg {
	word-wrap: break-word;
	font-size: 14px;
	color: var(--secondary-foreground);
	margin-top: 3px;
}

.HomeItem-textStrong-lO9Rw {
	font-weight: bold;
}

.HomeItem-reviewStar-wfn49 {
	display: inline;
	position: relative;
	float: left;
}

.HomeItem-instantIcon-J0s97 {
	color: var(--instantIcon-bg);
	height: 16px;
	width: 16px;
}

.HomeItem-infoSpace-dQe9w {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.HomeItem-pricingText-PwtCM {
	color: var(--primary-foreground);
	font-weight: 600;
	font-size: 22px;
}

.HomeItem-nightText-UBz8u {
	font-size: 16px;
	font-weight: 400;
}

.HomeItem-listReviewFlex-t8edW {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 5px;
}

@media (max-width:1023px) and (min-width:768px) {
	.HomeItem-infoTitle-u02Qa {
		font-size: 16px;
		margin-top: 0px;
	}

	.HomeItem-pricingText-PwtCM {
		font-size: 18px;
	}

	.HomeItem-nightText-UBz8u {
		font-size: 14px;
	}
}

.HomeItem-imageContent-NQcw0 {
	height: 100%;
	width: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	position: absolute;
	border-radius: 15px;
	background-color: var(--secondary-gray-bg);
}

/** Home slider Item - Start **/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Home/HomeItem/HomeItem.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA,aAAa;;AACb;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA,aAAa;;AACb,+BAA+B;;AAC/B;CACC,kBAAkB;CAClB,WAAW;CACX,oCAAoC;CACpC,mBAAmB;AACpB;;AAEA;CACC,2DAA2D;CAC3D,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,cAAc;CACd,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kCAAkC;CAClC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAGA;CACC,4BAA4B;CAC5B,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC;EACC,eAAe;EACf,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,0CAA0C;AAC3C;;AAEA,+BAA+B","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../helpers.css';\n\n/** Common **/\n.textEllipsis {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n/** Common **/\n/** Home slider Item - Start **/\n.imgContainer {\n\tposition: relative;\n\twidth: 100%;\n\tbackground: var(--secondary-gray-bg);\n\tborder-radius: 15px;\n}\n\n.parent {\n\tbackground: var(--secondary-gray-bg) none repeat scroll 0 0;\n\tpadding-top: 67.6667%;\n\tposition: relative;\n\tborder-radius: 15px;\n\toverflow: hidden;\n}\n\n.children {\n\tbottom: 0;\n\theight: 100%;\n\tleft: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n}\n\n.content {\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n}\n\n.imageContent {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tposition: absolute;\n}\n\n.infoContainer {\n\tposition: relative;\n}\n\n.linkContainer,\n.linkContainer:hover {\n\tdisplay: block;\n\ttext-decoration: none;\n\tcursor: pointer;\n}\n\n.infoReview {\n\tfont-size: 16px;\n\tfont-weight: 500;\n}\n\n.infoTitle {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tmargin-top: 3px;\n\tcolor: var(--primary-foreground);\n}\n\n.infoDesc {\n\tword-wrap: break-word;\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n\tmargin-top: 3px;\n}\n\n.textStrong {\n\tfont-weight: bold;\n}\n\n.reviewStar {\n\tdisplay: inline;\n\tposition: relative;\n\tfloat: left;\n}\n\n\n.instantIcon {\n\tcolor: var(--instantIcon-bg);\n\theight: 16px;\n\twidth: 16px;\n}\n\n.infoSpace {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.pricingText {\n\tcolor: var(--primary-foreground);\n\tfont-weight: 600;\n\tfont-size: 22px;\n}\n\n.nightText {\n\tfont-size: 16px;\n\tfont-weight: 400;\n}\n\n.listReviewFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 5px;\n}\n\n@media (max-width:1023px) and (min-width:768px) {\n\t.infoTitle {\n\t\tfont-size: 16px;\n\t\tmargin-top: 0px;\n\t}\n\n\t.pricingText {\n\t\tfont-size: 18px;\n\t}\n\n\t.nightText {\n\t\tfont-size: 14px;\n\t}\n}\n\n.imageContent {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tposition: absolute;\n\tborder-radius: 15px;\n\tbackground-color: var(--secondary-gray-bg);\n}\n\n/** Home slider Item - Start **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `HomeItem-space1-r8OMh`,
	"space2": `HomeItem-space2-w_6Dn`,
	"space3": `HomeItem-space3-nuqYJ`,
	"space4": `HomeItem-space4-HuTTx`,
	"space5": `HomeItem-space5-ZKcFU`,
	"space6": `HomeItem-space6-vCf5g`,
	"space7": `HomeItem-space7-Rr7FT`,
	"spaceTop8": `HomeItem-spaceTop8-pUzHz`,
	"spaceTop1": `HomeItem-spaceTop1-VxuDF`,
	"spaceTop2": `HomeItem-spaceTop2-i_nFw`,
	"spaceTop3": `HomeItem-spaceTop3-cpSC4`,
	"spaceTop4": `HomeItem-spaceTop4-btJ3O`,
	"spaceTop5": `HomeItem-spaceTop5-Rqx07`,
	"spaceTop6": `HomeItem-spaceTop6-zcWYh`,
	"spaceTop7": `HomeItem-spaceTop7-KaBcP`,
	"noMargin": `HomeItem-noMargin-hboDP`,
	"padding1": `HomeItem-padding1-DeNhq`,
	"padding2": `HomeItem-padding2-lepQ2`,
	"padding3": `HomeItem-padding3-CIBR8`,
	"padding4": `HomeItem-padding4-q0BSV`,
	"padding5": `HomeItem-padding5-pskaJ`,
	"padding6": `HomeItem-padding6-fBGxm`,
	"padding7": `HomeItem-padding7-Gbbx5`,
	"paddingTop1": `HomeItem-paddingTop1-VWkQy`,
	"paddingTop2": `HomeItem-paddingTop2-_ueB_`,
	"paddingTop3": `HomeItem-paddingTop3-iDPXy`,
	"paddingTop4": `HomeItem-paddingTop4-oQSdV`,
	"paddingTop5": `HomeItem-paddingTop5-_KtSr`,
	"paddingTop6": `HomeItem-paddingTop6-ONwil`,
	"paddingTop7": `HomeItem-paddingTop7-mbrAj`,
	"noPadding": `HomeItem-noPadding-TejZ8`,
	"textBold": `HomeItem-textBold-ENEZI`,
	"textBolder": `HomeItem-textBolder-GxpnC`,
	"textNormal": `HomeItem-textNormal-QVNnO`,
	"spaceBottom20": `HomeItem-spaceBottom20-PqUTg`,
	"spaceBottom10": `HomeItem-spaceBottom10-arU2L`,
	"marginNone": `HomeItem-marginNone-MmGFf`,
	"spaceBottom15": `HomeItem-spaceBottom15-N66FF`,
	"marginTopNone": `HomeItem-marginTopNone-GCRzF`,
	"spaceTop11": `HomeItem-spaceTop11-t03iT`,
	"spaceTop21": `HomeItem-spaceTop21-otN0q`,
	"spaceTop20": `HomeItem-spaceTop20-YWUb9`,
	"spaceTop10": `HomeItem-spaceTop10-PgcIC`,
	"textDarkBlue": `HomeItem-textDarkBlue-m4t_o`,
	"textLightBlue": `HomeItem-textLightBlue-BWA58`,
	"textLightSandleGreen": `HomeItem-textLightSandleGreen-VvoM3`,
	"textLightBrown": `HomeItem-textLightBrown-V3JRd`,
	"textMediumMaroon": `HomeItem-textMediumMaroon-hJVuq`,
	"textBrown": `HomeItem-textBrown-zk5Or`,
	"textMaroon": `HomeItem-textMaroon-EylgK`,
	"textDarkBrown": `HomeItem-textDarkBrown-VVaVc`,
	"textMediumBrown": `HomeItem-textMediumBrown-y0O3m`,
	"textSkyBlue": `HomeItem-textSkyBlue-mgZeT`,
	"textGray": `HomeItem-textGray-KVCcB`,
	"textEllipsis": `HomeItem-textEllipsis-aHUlH`,
	"imgContainer": `HomeItem-imgContainer-ccoyu`,
	"parent": `HomeItem-parent-B_6aP`,
	"children": `HomeItem-children-qYRqD`,
	"content": `HomeItem-content-NVJX7`,
	"imageContent": `HomeItem-imageContent-NQcw0`,
	"infoContainer": `HomeItem-infoContainer-RbJK0`,
	"linkContainer": `HomeItem-linkContainer-qZQbd`,
	"infoReview": `HomeItem-infoReview-pgMUd`,
	"infoTitle": `HomeItem-infoTitle-u02Qa`,
	"infoDesc": `HomeItem-infoDesc-rOoWg`,
	"textStrong": `HomeItem-textStrong-lO9Rw`,
	"reviewStar": `HomeItem-reviewStar-wfn49`,
	"instantIcon": `HomeItem-instantIcon-J0s97`,
	"infoSpace": `HomeItem-infoSpace-dQe9w`,
	"pricingText": `HomeItem-pricingText-PwtCM`,
	"nightText": `HomeItem-nightText-UBz8u`,
	"listReviewFlex": `HomeItem-listReviewFlex-t8edW`
};
module.exports = ___CSS_LOADER_EXPORT___;
